<template>
    <b-modal id="maxStklModal" :title="$t('direct-entry.modalTitle')" hide-footer>
            <b-container>

                <b-row class="col-md-12">
                    <b-col>{{$t('direct-entry.modalText')}}</b-col>
                </b-row>

                <b-row class="col-md-12 mt-3">
                        <ul>
                            <li class="text-primary selection" v-for="stkl in maximalStuecklisten" :key="stkl.id" @click="searchByMaxStklId(stkl.id)"> {{ stkl.name }}</li>
                        </ul>
                </b-row>
                <b-button class="btn mayr-button-blue float-right" @click="$bvModal.hide('maxStklModal')">{{$t('general.cancel')}}</b-button>

            </b-container>
    </b-modal>
</template>

<script>
    import searchByMaxStklId from "../../mixins/searchByMaxStklId";

    export default {
        name: "MaxStklModal",
        props: ['maximalStuecklisten'],
        mixins: [searchByMaxStklId]
    }
</script>

<style scoped>
    .selection { cursor: pointer;}
</style>